// src/Components/Share/ShareButton.tsx
// The "Share" button shown at a moment worth sharing. It opens the share
// sheet with the clip for that moment.
import React from "react";
import Icon from "../Ui/Icon";
import { openShare } from "./shareStore";
import type { ClipSpec } from "./clipModel";

interface Props {
  spec: ClipSpec | (() => ClipSpec | null);
  label?: string;
  variant?: "secondary" | "ghost" | "accent" | "icon";
  block?: boolean;
  className?: string;
  /** Runs before the sheet opens (e.g. close a full-screen celebration first). */
  before?: () => void;
  testId?: string;
}

const ShareButton: React.FC<Props> = ({ spec, label = "Share", variant = "secondary", block = false, className = "", before, testId = "share-open" }) => {
  const open = () => {
    const s = typeof spec === "function" ? spec() : spec;
    if (!s) return;
    before?.();
    openShare(s);
  };
  if (variant === "icon") {
    return (
      <button type="button" className={`mr-iconbtn share-iconbtn ${className}`} onClick={open} aria-label={label} data-testid={testId}>
        <Icon name="share" size={22} />
      </button>
    );
  }
  return (
    <button type="button" className={`mr-btn mr-btn--${variant} ${block ? "mr-btn--block" : ""} share-btn ${className}`} onClick={open} data-testid={testId}>
      <Icon name="share" size={20} />
      <span>{label}</span>
    </button>
  );
};

export default ShareButton;
